<div *ngIf="section" data-test="section-table-component">
  <div
    class="
      w-100
      d-inline-flex
      align-items-baseline
      justify-content-between
      table-title
    "
  >
    <h5
      *ngIf="section.title"
      class="title pb-2 m-0"
      data-test="section-title"
      >{{ section.title }}</h5
    >
    <ng-container
      *ngIf="section.action?.url && section.action?.title; else subtitle"
    >
      <a
        floAnalytics
        [routerLink]="section.action?.url"
        [analyticsProperties]="section.action?.analytics"
        [queryParams]="section.action?.mergeParams"
        data-test="section-action-title"
        class="
          footnote
          color-500
          hover-underline hover-grey-500
          mb-0
          pe-3 pe-sm-0
        "
      >
        {{ section.action?.title }}
      </a>
    </ng-container>
    <ng-template #subtitle>
      <h6
        *ngIf="section.subtitle1"
        class="subtitle pb-2 m-0"
        data-test="section-subtitle"
        >{{ section.subtitle1 }}</h6
      >
    </ng-template>
  </div>
  <div *ngFor="let table of section.items; trackBy: trackById; let i = index">
    <flo-table [table]="table"></flo-table>
  </div>
</div>
